import { useLocalStorage } from "./utils/LocalStorageHook";
import { DisplayRoleContext } from "./Context_api";
import { checkForRole } from "./utils/GetAuth";
/**
 * function for role provieder
 */
export function Role_Provider(props: any) {
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  return (
    <DisplayRoleContext.Provider
      value={{ isDisplayOnlyRole: (!checkForRole(clientId, salesOrg, "vs_submit_schedule") && 
        checkForRole(clientId, salesOrg, "vs_review") && 
        checkForRole(clientId, salesOrg, "vs_access"))}}
    >
      {props.children}
    </DisplayRoleContext.Provider>
  );
}
